import CmsImage from 'components/CmsImage';
// import { ContainerInner } from "elements";
import { Caption, CmsBannerStyled, PropTypes, ContainerInner } from './styled';

export function CmsBanner({
  imageId,
  title,
  subtitle,
  headline,
  buttonLink,
  buttonLabel,
}: PropTypes) {
  return (
    <CmsBannerStyled>
      <CmsImage id={imageId} alt={'Banner Image'} />
      {(title || subtitle || headline) && (
        <Caption>
          <ContainerInner>
            {title && <h1>{title}</h1>}
            {subtitle && <h2>{subtitle}</h2>}
            {headline && <p>{headline}</p>}
            {buttonLink && buttonLabel && (
              <p className="story-fake-link">{buttonLabel}&nbsp;&gt;</p>
            )}
          </ContainerInner>
        </Caption>
      )}
    </CmsBannerStyled>
  );
}
